module.exports = __webpack_public_path__ + "f56a1fc8a44c6b4e2e74ef3c62c3aac0.fbx";